import React from 'react'
import Registro from '../components/Registro/Registro';
import { Helmet } from 'react-helmet-async';

const Contact = () => {
  return (
    <div>
      {/* SEO */}
      <Helmet>
        <title>Diplomado en Ultrasonografía Diagnóstica - IMDI Tuxtla</title>        
        <meta name="description" content="Capacítate en ultrasonografía diagnóstica con IMDI Tuxtla. Diplomados en ultrasonido, ecografía y doppler materno fetal con expertos médicos." />
        <meta name="keywords" content="diplomados en ultrasonografía, ultrasonido diagnóstico, ecografía médica, doppler materno fetal, maestría en ultrasonografía" />
        <meta name="author" content="IMDI Tuxtla" />
        <link rel="canonical" href="https://imdituxtla.com.mx/Contact" />
      </Helmet>

      <Registro />
    </div>
  )
}

export default Contact